/**
 * ZL2b: het antwoord zonder de blokken eronder, zoals het scherm het als tekst toont. Dit is wat
 * "Overnemen" kopieert en waar "Aanpassen" mee begint. Gelijk aan `zichtbare_tekst` in
 * `backend/services/overnames.py`, die op dezelfde drie merktekens knipt; de toets ernaast eist dat.
 */
import { MERK as AGENDAMERK } from "./agendablok";
import { MERK as TAAKMERK } from "./taakblok";
import { MERK as TABELMERK } from "./tabelblok";

export const BLOKMERKEN = [AGENDAMERK, TAAKMERK, TABELMERK];

/** PUUR. */
export function zichtbareTekst(inhoud) {
  const tekst = inhoud || "";
  const plekken = BLOKMERKEN.map((m) => tekst.indexOf(m)).filter((i) => i !== -1);
  return plekken.length ? tekst.slice(0, Math.min(...plekken)) : tekst;
}
